import React from 'react';
import PropTypes from 'prop-types';
import './details-table-owners-list.scss';

const DetailsTableOwnersList = ({ entity }) => {
  const { owner_dict } = entity;

  const getOwnerCards = owners => owners.map(owner => (
    <div styleName="owner-card" key={owner.id} role="presentation">
      <div styleName="title">
        {owner.name}
      </div>
      <div styleName="body">
        {owner.email}{owner.phone ? ', ' : ''}{owner.phone}
      </div>
    </div>
  ));

  return (
    <div styleName="owners-container">
      {owner_dict.length === 0 &&
        <div styleName="empty-list">No owners to show</div>
      }
      {owner_dict.length > 0 &&
        <div styleName="owners-list">{getOwnerCards(owner_dict)}</div>
      }
    </div>
  );
};

DetailsTableOwnersList.propTypes = {
  entity: PropTypes.object
};

export default DetailsTableOwnersList;
